<template>
	<div>
		<app-header></app-header>
        <div v-scroll="loadMore" style="height: 680px; overflow: auto;">
            <Row style="margin-top: 40px;">
                <Col span="1">
                    &nbsp;
                </Col>
                <Col span="4">
                    <app-left></app-left>
                </Col>
                <Col span="15">
                    <ul style="list-style:none"> 
                        <li class="project" v-for="(project, index) in projectList">
                            <p v-for="(userDetail, index) in userDetailList" v-if="project.creatorId == userDetail.userId">
                                <Row>
                                    <Col span="4">
                                        <span @click="userInformation(userDetail.userId)">
                                            <a>{{userDetail.nickName}}</a>
                                        </span>
                                    </Col>
                                    <Col span="6">
                                        <span @click="projectDetail(project.projectId, userDetail.userId)">
                                            <a>{{project.projectName}}</a>
                                        </span>
                                    </Col>
                                     <Col span="2">
                                        {{dateFormat(project.creationTime)}}
                                    </Col>
                                </Row>
                            </p>
                            <Row>
                                <Col span="4">&nbsp;</Col>
                                <Col span="10">{{project.projectDesc}}</Col>
                                
                            </Row>
                        </li>
                        <div align="center">
                            <Button v-if="isLoading" type="text" loading>loading...</Button>
                            <Button v-if="isNoMoreData" type="text">no more data</Button>
                        </div>
                    </ul>
                </Col>
                <Col span="4">
                    <div class="postmiddle-right" style="background-color: white;margin: 0px auto;text-align: center;">
                        <ul style="list-style: none;font-size: 16px;">
                            <li><a @click="createProject">创建项目</a></li>
                        </ul>
                    </div>
                </Col>
            </Row>
            <!-- <Row>
                <li v-show="isLoading" style="margin-bottom: 200px;">loading...</li>
            </Row> -->
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                //当前页码，从0开始
                pageNo: 0,
                //每次查询几条数据
                pageSize: 5,
                isLoading: false,
                isNoMoreData: false,
                //是否发送请求
                isSendRequest: true,
                projectList: [],
                userDetailList: [],
            }
        },
        mounted(){
            this.findProject();
            // this.$http.get(config.baseUrl + 'project/test').then(res => {
            //   this.newslist = [...this.newslist, ...res.data.result];
            // });
            // this.a();
        },
        create(){
            
        },
        directives: { 
            scroll: {//自定义标签，用来无限加载
                bind: function (el, binding){
                    el.addEventListener('scroll', () => {
                        const containerHeight = el.clientHeight;
                        const scrollTop = el.scrollTop;
                        const contentHeight = el.scrollHeight;
                        if (scrollTop + containerHeight >= contentHeight) {
                            binding.value();
                        }
                    });
                } 
            } 
        },
       
        methods: {
            findProject:function(){
                if(this.isSendRequest){
                    let url = config.baseUrl + "project/projectList/" + this.pageNo + "/" + this.pageSize;
                    this.$http.get(url).then(function(successData){
                        let data = successData.data;
                        this.projectList = data.result.projectList;
                        this.userDetailList=data.result.userDetailList;
                        this.pageNo = this.pageNo + 1;
                    },function(errorData){
                       this.$Message.error('Error!');
                    });
                }
            },
            loadMore:function(){
                if (this.isLoading) {
                    //如果是加载中，直接return，防止重复加载
                    return;
                }
                if(this.isSendRequest){
                    this.isLoading = true;
                    let url = config.baseUrl + "project/projectList/" + this.pageNo + "/" + this.pageSize;
                    this.$http.get(url).then(successData => {
                        let data = successData.data;
                        if (data.resCode == 0) {
                            //将查询出来的结果继续加到集合尾部
                            this.projectList = [...this.projectList, ...data.result.projectList];
                            let udList = data.result.userDetailList;
                            //如果新查询出来的UserDetail与集合中的重复，就将其删除
                            for (let i = 0; i < this.userDetailList.length; i++) {
                                for (let j = 0; j < udList.length; j++) {
                                    if (this.userDetailList[i].id == udList[j].id) {
                                        //删除数组中的这个对象
                                        udList.splice(j, 1);
                                    }
                                }
                            }
                            //将最终没有重复的对象添加到已有的集合中
                            this.userDetailList = [...this.userDetailList, ...udList];
                            this.pageNo = this.pageNo + 1;
                        }
                        this.isLoading = false;
                        if (data.resCode == -1) {
                            //此时已经没有数据了,3s后关闭提醒，并且不再发请求加载数据
                            this.isSendRequest = false;
                            this.isNoMoreData = true;
                            setTimeout(() => {
                                this.isNoMoreData = false;
                            }, 3000);
                        }
                    });
                }
            },
            //用户资料
            userInformation:function(userId){
                this.$router.push({name:'userInformation',params:{userId: userId}})
            },
            projectDetail:function(projectId, userId){
                this.$router.push({name:'projectDetail',params:{projectId:projectId,userId:userId}});
            },
            createProject:function(){
                this.$router.push({name:'createProject'})
            },
            //时间格式化函数
            dateFormat(time) {
                return formatDate(time);
            },
        },
    }
</script>
<style>
    .project {
        height: 100px;
        margin-top: 60px;
        border: 1px solid #eee;
    }
</style>


// WEBPACK FOOTER //
// ProjectIndex.vue?4e18f8c9